<template>
  <q-layout view="lHh Lpr lFf">
    <Layout />
  </q-layout>
</template>

<script>
import Layout from "./layouts/index.vue";

export default {
  components: {
    Layout,
  },
};
</script>